import { IColumnConfig } from "dots-ui/dotsTable";
import { AvisConstants } from "../../../data/avisConstants";
import { InvoiceListInfo } from "../../../generated/data-contracts";
import { ILinkValue, ResCallback } from "../../../models";
import { LicenseesUrls, LicenseesUtils, TableUtils, api } from "../../../utils";

export const columnConfigInvoices = (
  archive: boolean,
  res: ResCallback,
): IColumnConfig[] => {
  const columnCollection: IColumnConfig[] = [
    TableUtils.columnConfigDateTime<InvoiceListInfo>(
      "dueDate",
      res("licensees_Invoice_label_DueDate"),
      undefined,
      115,
    ),
    TableUtils.columnConfigString<InvoiceListInfo>(
      "number",
      res("licensees_Invoice_label_Number"),
    ),
    TableUtils.columnConfigLink<InvoiceListInfo>(
      "licenseNumber",
      res("licensees_License_label_License"),
      (rowData) => {
        const licenseTargetView = rowData.licenseIsGrouped
          ? LicenseesUrls.licenseeLicenseViewChildLicenses
          : LicenseesUrls.licenseeLicenseView;
        return {
          title: rowData.licenseNumber,
          url: LicenseesUtils.getUrlWithParams(licenseTargetView, {
            licenseId: rowData.licenseHeaderId,
          }),
        } as ILinkValue;
      },
    ),
    TableUtils.columnConfigPeriod<InvoiceListInfo>(
      "dateFrom",
      "dateTo",
      res("label_ReportPeriod"),
      undefined,
      AvisConstants.table_column_period_width,
    ),
    TableUtils.columnConfigString<InvoiceListInfo>(
      "licensePayorName",
      res("licensees_Invoice_label_Payor"),
    ),
    TableUtils.columnConfigMoney<InvoiceListInfo>(
      "amount",
      res("licensees_Invoice_label_Amount"),
    ),
    ...(!archive
      ? [
          TableUtils.columnConfigMoney<InvoiceListInfo>(
            "amountToPay",
            res("licensees_Invoice_label_AmountToPay"),
          ),
        ]
      : []),
    TableUtils.columnConfigDownloadInvoicePdfXml<InvoiceListInfo>(
      "uniqueId",
      res("label_Download"),
      (rowData) =>
        api.licenseesGetInvoicePdf(rowData.uniqueId, {
          format: "arraybuffer",
        }),
      (rowData) =>
        api.licenseesGetInvoiceXml(rowData.uniqueId, {
          format: "arraybuffer",
        }),
    ),
  ];
  return columnCollection;
};
